import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Home from "@/pages/Home";
import RecipeResult from "@/pages/RecipeResult";
import RecipeLibrary from "@/pages/RecipeLibrary";
import FoodSearch from "@/pages/FoodSearch";
import RecipeBuilder from "@/pages/RecipeBuilder";
import DailyLog from "@/pages/DailyLog";
import RecipeCompare from "@/pages/RecipeCompare";
import WebSearch from "@/pages/WebSearch";
import Grocery from "@/pages/Grocery";
import MealPlanner from "@/pages/MealPlanner";
import KidCard from "@/pages/KidCard";
import RecipeRemix from "@/pages/RecipeRemix";
import VoiceCook from "@/pages/VoiceCook";
import NutrientCalculatorLanding from "@/pages/NutrientCalculatorLanding";
import MealPlannerLanding from "@/pages/MealPlannerLanding";
import GroceryPlannerLanding from "@/pages/GroceryPlannerLanding";

const TOAST_OPTIONS = {
  style: { fontFamily: "'JetBrains Mono', monospace", borderRadius: 0 },
};

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Header />
        <main data-testid="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/builder" element={<RecipeBuilder />} />
            <Route path="/planner" element={<MealPlanner />} />
            <Route path="/planner/:id/kid-card" element={<KidCard />} />
            <Route path="/search" element={<WebSearch />} />
            <Route path="/log" element={<DailyLog />} />
            <Route path="/grocery" element={<Grocery />} />
            <Route path="/compare" element={<RecipeCompare />} />
            <Route path="/library" element={<RecipeLibrary />} />
            <Route path="/database" element={<FoodSearch />} />
            <Route path="/recipe/:id" element={<RecipeResult />} />
            <Route path="/recipe/:id/remix" element={<RecipeRemix />} />
            <Route path="/recipe/:id/cook" element={<VoiceCook />} />
            <Route path="/share/:id" element={<RecipeResult readOnly />} />
            {/* SEO landing pages */}
            <Route path="/nutrient-calculator" element={<NutrientCalculatorLanding />} />
            <Route path="/meal-planner" element={<MealPlannerLanding />} />
            <Route path="/grocery-planner" element={<GroceryPlannerLanding />} />
          </Routes>
        </main>
        <Toaster position="top-right" toastOptions={TOAST_OPTIONS} />
      </BrowserRouter>
    </div>
  );
}

export default App;
